var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 12.5C11.25 13.1904 10.6904 13.75 10 13.75C9.30964 13.75 8.75 13.1904 8.75 12.5C8.75 11.8096 9.30964 11.25 10 11.25C10.6904 11.25 11.25 11.8096 11.25 12.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.83313 13.75C6.52349 13.75 7.08313 13.1904 7.08313 12.5C7.08313 11.8096 6.52349 11.25 5.83313 11.25C5.14277 11.25 4.58313 11.8096 4.58313 12.5C4.58313 13.1904 5.14277 13.75 5.83313 13.75Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4169 12.5C15.4169 13.1904 14.8572 13.75 14.1669 13.75C13.4765 13.75 12.9169 13.1904 12.9169 12.5C12.9169 11.8096 13.4765 11.25 14.1669 11.25C14.8572 11.25 15.4169 11.8096 15.4169 12.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1.66667H15.8333C16.938 1.66799 17.997 2.1074 18.7782 2.88852C19.5593 3.66963 19.9987 4.72867 20 5.83333V15.8333C19.9987 16.938 19.5593 17.997 18.7782 18.7782C17.997 19.5593 16.938 19.9987 15.8333 20H4.16667C3.062 19.9987 2.00296 19.5593 1.22185 18.7782C0.440735 17.997 0.00132321 16.938 0 15.8333V5.83333C0.00132321 4.72867 0.440735 3.66963 1.22185 2.88852C2.00296 2.1074 3.062 1.66799 4.16667 1.66667H5V0.833333C5 0.61232 5.0878 0.400358 5.24408 0.244078C5.40036 0.0877974 5.61232 0 5.83333 0C6.05435 0 6.26631 0.0877974 6.42259 0.244078C6.57887 0.400358 6.66667 0.61232 6.66667 0.833333V1.66667H13.3333V0.833333C13.3333 0.61232 13.4211 0.400358 13.5774 0.244078C13.7337 0.0877974 13.9457 0 14.1667 0C14.3877 0 14.5996 0.0877974 14.7559 0.244078C14.9122 0.400358 15 0.61232 15 0.833333V1.66667ZM2.3989 4.06557C1.93006 4.53441 1.66667 5.17029 1.66667 5.83333V6.66667H18.3333V5.83333C18.3333 5.17029 18.0699 4.53441 17.6011 4.06557C17.1323 3.59673 16.4964 3.33333 15.8333 3.33333H4.16667C3.50363 3.33333 2.86774 3.59673 2.3989 4.06557ZM2.3989 17.6011C2.86774 18.0699 3.50363 18.3333 4.16667 18.3333H15.8333C16.4964 18.3333 17.1323 18.0699 17.6011 17.6011C18.0699 17.1323 18.3333 16.4964 18.3333 15.8333V8.33333H1.66667V15.8333C1.66667 16.4964 1.93006 17.1323 2.3989 17.6011Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.7e2ef3f62ab3df483c8145d8b7004fa3.svg";
export { ForwardRef as ReactComponent };